<template>
  <div class="row">
  <b-card class="col-9">
    <b-row class="mt-2">
      <b-form-input 
        v-model="filtersTemp.search" 
        placeholder="Buscar por cedula, nombre, apellido paciente o doctor"
        type="text" class="col-6" 
      />
<!-- 
      <v-select 
        v-model="filtersTemp.establecimiento" 
        :options="establecimientosOpts"
        :reduce="(option) => option.value" 
        placeholder="Establecimiento" 
        label="text"
        class="col-2" 
      /> -->

      <v-select 
        v-model="filtersTemp.especialidad" 
        :options="especialidadesOpts" 
        placeholder="Especialidad"
        :reduce="(option) => option.value" 
        label="text" 
        class="col-4" 
      />

      <v-select 
        id="estado" 
        v-model="filtersTemp.estado" 
        :options="estadosOpts" 
        placeholder="Estado"
        :reduce="(option) => option.value" 
        label="text" 
        class="col-2" 
      />


      <flat-pickr
        v-model="filtersTemp.fechaDesde"
        placeholder="Fecha Programada Desde:"
        class="form-control col-2 mt-1"
      />

      <flat-pickr
        v-model="filtersTemp.fechaHasta"
        placeholder="Fecha Programada Hasta:"
        class="form-control col-2 ml-1 mt-1"
      />


      <b-col class="ml-4 mt-1"> 
        <b-button 
          variant="primary" 
          @click="onSetFilters"
        >
          <font-awesome-icon icon="magnifying-glass" style="color: white" />
          <span style="color: white"> Buscar</span>
        </b-button>
        
        <b-button 
          class="ml-1" 
          variant="warning" 
          title="Limpiar filtros"
          @click="onClearFilters"
        >

        
          <i class="fa-solid fa-recycle"/>
        </b-button>
         <b-button 
          v-if="canDownloadExcel"
          class="ml-1" 
          variant="outline-secondary" 
          title="Generar Excel Procedimientos"
          @click="onGenerateExcel"
          :disabled="descargandoExcel"
        >
      <i class="fa-solid fa-sheet-plastic"/></b-button>
      </b-col>

    </b-row>
  </b-card>
  <b-card class="col-3" >
      <div >
        <h5 class="mb-1">Observaciones: </h5>
        
        <div class="d-flex align-items-center">
          <h4 class="mb-0">Programados sin MSP:</h4>
          
          <span class="ml-1">{{ sinMsp }} (total)</span>

          <b-form-checkbox
            v-model="filtersTemp.observaciones"
            :value="'sinMsp'"
            switch 
            size="md"
            class="ml-2"
          />
        </div>
        
      </div>
    </b-card>
  </div> 
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from "vue-flatpickr-component";
import { establecimientosService, especialidadesService } from "@/views/administracion/services";
import { procedimientosService } from '../services';
import actions from '../../../assets/utils/utils';
import { ROLES } from '../../../shared/constants';
import { comprobarRoles } from '../../../shared/helpers';


export default {
  name: 'FiltersProcesos',

  components: {
    vSelect,
    flatPickr
  },


  async created() {
    this.loadInitData();
    this.loadFiltersLS();
    
  },

  props:{
    sinMsp:{
      default:null,
      required:false
    }
  },



  data() {
    return {

      filtersTemp: {
        search: null,
        establecimiento: null,
        especialidad: null,
        estado: null,
        fechaDesde: null,
        fechaHasta: null,
        excel:null,
        observaciones:null
      },

      descargandoExcel:false,

      filters: null,

      establecimientosOpts: [],
      especialidadesOpts: [],

      estadosOpts: [
        { value: "creada",     text: "Creada" },
        { value: "programada", text: "Programado" },
        { value: "ejecutada",  text: "Ejecutada" },
        
      ],

      optionsFecha : [
        { text : "Fecha programación", value : "1" }, 
        { text : "Fecha atención",     value : "2" }
      ],

    }
  },

  methods: {

    async loadInitData() {
      //this.establecimientosOpts = await establecimientosService.getForSelect();
      this.especialidadesOpts   = await especialidadesService.getOptionsSelect();
    },


    loadFiltersLS(){
      const dataFilters = JSON.parse(localStorage.getItem('filterProcesos'));
      if(dataFilters) {
        this.filtersTemp = dataFilters;
      }
      this.onSetFilters();
    },



    onSetFilters(){
      this.filters = { ...this.filtersTemp };
    },


    onClearFilters(){
      this.filtersTemp = {
        search         : null,
        //establecimiento: null,
        especialidad   : null,
        estado         : null,
        fechaDesde     : null,
        fechaHasta     : null,
        excel          : null, 
      }

      this.onSetFilters();
    },

    async onGenerateExcel(){

      const params = {
        ...this.filtersTemp,
        excel : '1'
      }
      
      this.descargandoExcel = true

      const responseProcesos = await procedimientosService.getAll(params);
      this.descargandoExcel = false
      if (!responseProcesos) return;

      
      const blobExcel = responseProcesos.blob
      actions.cargarArchivos(blobExcel,  "reporte-procedimientos.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
  
    }
  },

  
  computed:{

    canDownloadExcel(){
      return comprobarRoles( [ROLES.AUDITOR, ROLES.JEFE_AUDITOR, ROLES.AGENDAMIENTO, ROLES.JEFE_VALIDACIONES, ROLES.JEFE_MEDICO, ROLES.JEFE_DERIVADOR] );
    },

   
  
  },


  watch:{
    filters:{
      deep: true,
      immediate: true,
      handler(){
        if(!this.filters) return;
        localStorage.setItem('filterProcesos', JSON.stringify(this.filters));
        this.$store.commit('setFilterProcesos', this.filters);
      }
    }
  }

}

</script>